// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Plans Responsive Styles */
.test-plans-container {
  width: 100%;
  max-width: 100%;
  overflow: visible;
  padding: 0;
  box-sizing: border-box;
  background: transparent;
  color: var(--text-primary);
}

/* Header Styles */
.test-plans-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px 0;
  border-bottom: 1px solid var(--border);
}

.header-with-back {
  display: flex;
  align-items: center;
  gap: 15px;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-secondary);
  font-weight: 500;
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: var(--bg-tertiary);
}

.test-plans-title {
  margin: 0;
  color: var(--text-primary);
  font-size: 28px;
  font-weight: 600;
}

.test-plans-subtitle {
  margin: 5px 0 0;
  color: var(--text-muted);
  font-size: 16px;
}

.test-plans-actions {
  display: flex;
  gap: 12px;
}

.test-plans-header--embedded {
  justify-content: flex-end;
  padding-top: 0;
  margin-bottom: 12px;
}

.rt-plans-entity-embed .entity-layout {
  min-height: 480px;
}

/* Project Selection */
.project-selection {
  margin-bottom: 20px;
}

.project-selection label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-secondary);
}

.project-dropdown {
  width: 100%;
  max-width: 350px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 16px;
  background-color: var(--surface);
}

/* Entity Layout */
.entity-layout {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}

.entity-left-panel {
  flex: 0 0 320px;
  min-width: 0;
}

.entity-right-panel {
  flex: 1 1;
  min-width: 0;
}

/* Entity Tabs */
.entity-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 15px;
}

.tab-btn {
  padding: 10px 20px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-weight: 500;
  color: var(--text-muted);
  transition: all 0.2s ease;
}

.tab-btn.active {
  color: #4361ee;
  border-bottom-color: #4361ee;
}

.tab-btn:hover:not(.active) {
  color: var(--text-secondary);
}

/* Entity List */
.entity-list-container {
  background: var(--surface);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-bottom: 20px;
}

.entity-list-container .pagination {
  flex-wrap: wrap;
  gap: 0.4rem;
  margin: 1rem 0 0;
}

.entity-list-container .pageItem {
  padding: 0.4rem 0.5rem;
  min-width: 32px;
  font-size: 0.85rem;
}

.entity-list-container .navButton {
  padding: 0.4rem 0.6rem;
}

.entity-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.sidebar-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.add-sprint-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #4361ee;
  background-color: #4361ee;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-sprint-btn:hover {
  background-color: #3a56d4;
}

/* Entity Grid */
.entity-grid {
   display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.entity-item {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  min-width: 0; 
  flex-shrink: 0;
}

.entity-item:hover {
  border-color: #4361ee;
  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.15);
}

.entity-item.active {
  border-color: #4361ee;
  background-color: #f8f9ff;
}

.entity-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.entity-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.entity-name {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3;
}

.entity-name-compact {
  flex: 0 1 auto;
  display: block;
  -webkit-line-clamp: unset;
  overflow: visible;
}

.entity-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--surface);
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background-color: var(--bg-primary);
}

.action-btn.edit:hover {
  border-color: var(--warning);
  color: var(--warning);
}

.action-btn.delete:hover {
  border-color: var(--danger);
  color: var(--danger);
}

.entity-description {
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

.entity-dates {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  color: var(--text-muted);
}

.entity-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  min-width: 0;
}

.entity-meta .assignee {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: var(--text-muted);
}

/* Status Badges */
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background-color: #d4edda;
  color: #155724;
}

.status-completed {
  background-color: #d1ecf1;
  color: #0c5460;
}

.status-planned {
  background-color: #fff3cd;
  color: #856404;
}

.status-default {
  background-color: var(--bg-primary);
  color: var(--text-secondary);
}

.priority-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.priority-high {
  background-color: #f8d7da;
  color: #721c24;
}

.priority-medium {
  background-color: #fff3cd;
  color: #856404;
}

.priority-low {
  background-color: #d1ecf1;
  color: #0c5460;
}

.priority-default {
  background-color: var(--bg-primary);
  color: var(--text-secondary);
}

/* Test Plans Table */
.entity-test-plans {
  background: var(--surface);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  overflow: visible;
  max-width: 100%;
}

.test-plans-table-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.section-title {
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
}

.test-plans-actions-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.navbar-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.navbar-button.primary {
  background-color: #4361ee;
  border: 1px solid #4361ee;
  color: white;
}

.navbar-button.primary:hover {
  background-color: #3a56d4;
  border-color: #3a56d4;
}

.navbar-button.secondary {
  background-color: #f5f5f5;
  border: 1px solid var(--border);
  color: var(--text-primary);
}

.navbar-button.secondary:hover {
  background-color: var(--bg-tertiary);
  border-color: #adb5bd;
}

/* Table Container — page scrolls vertically; table scrolls horizontally */
.table-responsive-wrapper {
  width: 100%;
  max-width: 100%;
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  /* Keep sticky thead z-index local so it cannot paint above GlobalLoader. */
  isolation: isolate;
  position: relative;
  z-index: 0;
}

.test-plans-table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  table-layout: auto;
}

.test-plans-table thead {
  position: sticky;
  top: 0;
  z-index: 100;

}

.test-plans-table th {
  background-color: var(--bg-primary);
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.test-plans-table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

.test-plans-table th.column-name,
.test-plans-table td.column-name {
  width: 28%;
  min-width: 180px;
  max-width: 320px;
  overflow: hidden;
}

/* Override global .column-actions max-width (projects.css) so all icons fit */
.test-plans-table th.column-actions,
.test-plans-table td.column-actions {
  width: 1%;
  min-width: 300px;
  max-width: none;
  white-space: nowrap;
  overflow: visible;
  vertical-align: middle;
}

.test-plans-table th.column-actions {
  padding-left: 72px;
  text-align: left;
}

.test-plans-table th.column-execution-history,
.test-plans-table td.column-execution-history {
  width: 12%;
  min-width: 120px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  overflow: visible;
}

.test-plans-table .column-execution-history .action-btn.execution-history {
  background: none;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-muted);
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  line-height: 0;
}

.test-plans-table .column-execution-history .action-btn.execution-history:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.08);
  color: #007bff;
}

.test-plans-table .column-execution-history .action-btn.execution-history svg {
  width: 16px;
  height: 16px;
  display: block;
  pointer-events: none;
}

/* Test Plan Header */
.test-plan-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.test-plan-header input[type="checkbox"] {
  margin-top: 3px;
  flex-shrink: 0;
}

.test-plan-name-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.test-plan-name-content {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.test-plan-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  font-weight: 500;
}

.test-plan-description {
  color: var(--text-muted);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.expand-row-btn {
  flex-shrink: 0;
  margin-left: 8px;
  font-weight: bold;
}

.expand-row-btn:hover {
  color: #4361ee;
}

.expand-row-btn.expanded {
  transform: rotate(180deg);
}

/* Progress Bar */
.progress-bar-container {
  width: 100%;
  height: 24px;
  background-color: var(--bg-tertiary);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #4361ee;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 600;
  color: white;
}

/* Test Suites */
.test-suites-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.test-suite-badge {
  padding: 4px 8px;
  background-color: var(--bg-tertiary);
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.test-suite-badge:hover {
  background-color: #dee2e6;
}

.test-suite-badge.clickable:hover {
  background-color: #4361ee;
  color: white;
}

.no-suites {
  color: var(--text-muted);
  font-style: italic;
  font-size: 14px;
}

/* Pass Rate */
.pass-rate-low {
  color: var(--danger);
  font-weight: 600;
}

.pass-rate-medium {
  color: var(--warning);
  font-weight: 600;
}

.pass-rate-high {
  color: var(--success);
  font-weight: 600;
}

/* Action Buttons */
.test-plans-table .action-buttons {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 6px;
  justify-content: flex-start;
  align-items: center;
  width: max-content;
  min-width: max-content;
  white-space: nowrap;
  overflow: visible;
}

.test-plans-table .action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid var(--border);
  background: var(--surface);
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.action-btn:hover {
  background-color: var(--bg-primary);
}

.action-btn.view:hover {
  border-color: #4361ee;
  color: #4361ee;
}

.action-btn.schedule:hover {
  border-color: #6f42c1;
  color: #6f42c1;
}

.action-btn.play:hover {
  border-color: var(--success);
  color: var(--success);
}

.action-btn.edit:hover {
  border-color: var(--warning);
  color: var(--warning);
}

.action-btn.delete:hover {
  border-color: var(--danger);
  color: var(--danger);
}

.action-btn.link:hover {
  border-color: var(--info);
  color: var(--info);
}

.action-btn.unlink:hover {
  border-color: #fd7e14;
  color: #fd7e14;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn:disabled:hover {
  background-color: var(--surface);
  border-color: #dee2e6;
  color: var(--text-muted);
}

/* Expanded Row */
.expanded-row td {
  background-color: var(--bg-primary);
  padding: 0;
}

.expanded-content {
  padding: 20px;
}

.expanded-section h4 {
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.suites-table-container {
  overflow-x: auto;
}

.suites-table {
  width: 100%;
  border-collapse: collapse;
}

.suites-table th {
  background-color: var(--bg-tertiary);
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: var(--text-secondary);
  border-bottom: 1px solid #dee2e6;
}

.suites-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
}

.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.badge-success {
  background-color: #d4edda;
  color: #155724;
}

.badge-disabled {
  background-color: #f8d7da;
  color: #721c24;
}

.no-suites-message {
  text-align: center;
  padding: 20px;
  color: var(--text-muted);
}

.btn-link-suites {
  padding: 8px 16px;
  background-color: #4361ee;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  transition: all 0.2s ease;
}

.btn-link-suites:hover {
  background-color: #3a56d4;
}

/* Pagination */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 10px 0;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-muted);
}

.empty-state p {
  margin: 0 0 15px;
  font-size: 16px;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4361ee;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
}

.loading-spinner.small {
  width: 24px;
  height: 24px;
  border-width: 2px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error States */
.error-container {
  text-align: center;
  padding: 60px 20px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.error-state {
  text-align: center;
  padding: 30px 20px;
  color: var(--danger);
}

/* Action Feedback — above schedule/create modals (z-index 11000) */
.action-feedback {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: white;
  font-weight: 500;
  z-index: 12000;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease;
}

.action-feedback.success {
  background-color: var(--success);
}

.action-feedback.error {
  background-color: var(--danger);
}

.action-feedback.warning {
  background-color: var(--warning);
  color: var(--text-primary);
}

.action-feedback.info {
  background-color: var(--info);
}

.action-feedback button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Create Test Execution modal — scoped to avoid global .modal slide/transform conflicts */
.test-execution-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12000;
  animation: testExecutionOverlayFadeIn 0.12s ease-out;
}

.test-execution-modal {
  background: var(--modal-background, var(--surface));
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: var(--modal-shadow, 0 10px 30px rgba(0, 0, 0, 0.2));
  position: relative;
  transform: none;
  box-sizing: border-box;
}

.test-execution-modal .modal-header {
  flex: 0 0 auto;
  background: var(--modal-background, var(--surface, #fff));
  padding: 16px 20px;
  border-bottom: 1px solid var(--border, #e2e8f0);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 12px 12px 0 0;
}

.test-execution-modal .modal-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary, #0f172a);
}

.test-execution-modal-form {
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}

.test-execution-modal .modal-content {
  min-height: 0;
  padding: 20px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.test-execution-modal .modal-footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  background-color: var(--bg-primary);
  border-radius: 0 0 8px 8px;
}

.test-execution-modal .form-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin: 0;
}

.test-execution-modal .form-group {
  margin-bottom: 0;
}

.test-execution-modal .form-group > label {
  display: block;
  margin: 0 0 6px;
  min-height: 0;
  line-height: 1.25;
  font-weight: 500;
  color: var(--text-secondary);
}

.test-execution-modal .form-row > .form-group {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.test-execution-modal .form-row > .form-group > input,
.test-execution-modal .form-row > .form-group > select,
.test-execution-modal .form-row > .form-group > .relative {
  width: 100%;
  box-sizing: border-box;
}

.test-execution-modal .test-execution-field-error {
  margin: 4px 0 0;
  padding: 0;
  border: none;
  background: none;
  color: var(--danger);
  font-size: 12px;
  line-height: 1.3;
  font-weight: 500;
}

.test-execution-modal .test-execution-field-hint {
  margin: 4px 0 0;
  padding: 0;
  font-size: 0.85rem;
  line-height: 1.3;
  color: var(--text-muted);
}

.test-execution-modal .test-execution-field-hint--success {
  color: var(--success);
}

.test-execution-modal .form-info {
  margin: 0;
}

.test-execution-modal .form-info p {
  margin: 0 0 4px;
}

.test-execution-modal .form-info p:last-child {
  margin-bottom: 0;
}

@keyframes testExecutionOverlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* padding: 20px; */
}

.modal {
  background: var(--surface);
  border-radius: 8px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--border);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted);
  transition: all 0.2s ease;
}

.modal-close:hover {
  color: var(--text-primary);
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid var(--border);
}

.btn {
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #4361ee;
  border: 1px solid #4361ee;
  color: white;
}

.btn-primary:hover {
  background-color: #3a56d4;
  border-color: #3a56d4;
}

.btn-outline {
  background-color: var(--surface);
  border: 1px solid var(--border);
  color: var(--text-secondary);
}

.btn-outline:hover {
  background-color: var(--bg-primary);
}

/* Schedule Modal — scoped to avoid global .modal slide/transform conflicts */
.schedule-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: var(--modal-backdrop, rgba(0, 0, 0, 0.5));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11000;
  animation: scheduleModalOverlayFadeIn 0.12s ease-out;
}

.schedule-modal {
  background: var(--surface);
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  position: relative;
  top: auto;
  left: auto;
  transform: none;
  animation: none;
  display: flex;
  flex-direction: column;
}

.schedule-modal .modal-header {
  background: var(--modal-background, var(--surface, #fff));
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 12px 12px 0 0;
  flex: 0 0 auto;
}

.schedule-modal .modal-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
}

.schedule-modal .modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

.schedule-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  background-color: var(--bg-primary);
  border-radius: 0 0 8px 8px;
  flex: 0 0 auto;
}

@keyframes scheduleModalOverlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.schedule-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-column {
  flex: 1 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: var(--text-secondary);
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.2);
}

.comment-textarea {
  resize: vertical;
  min-height: 100px;
}

.full-width {
  width: 100%;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .entity-layout {
    flex-direction: column;
  }
  
  .entity-left-panel {
    flex: 1 1;
    width: 100%;
  }
  
  .entity-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  
  .test-plans-table {
    min-width: 1100px;
  }
}

@media (max-width: 992px) {
  .test-plans-table {
    min-width: 1000px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
@media (max-width: 768px) {
  .test-plans-actions-container {
    justify-content: flex-start;
    gap: 8px;
  }
  
  .test-plans-actions-container .navbar-button {
    padding: 6px 10px;
    font-size: 14px;
  }
  

  .test-plans-actions-container .navbar-button.responsive-btn span {
    display: none;
  }
  
  .test-plans-actions-container .navbar-button.responsive-btn {
    padding: 8px;
    width: 40px;
    justify-content: center;
  }
}

/* High zoom level specific styles */
@media (min-resolution: 150dpi) {
  .test-plans-actions-container {
    gap: 6px;
  }
  
  .test-plans-actions-container .navbar-button {
    padding: 6px 10px;
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .action-buttons {
    flex-wrap: wrap;
    justify-content: center;
  }

  .test-plans-table .action-buttons {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  
  .test-plans-table td {
    white-space: normal;
  }
  .test-plans-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .test-plans-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .test-plans-actions-container {
     display: flex;
  flex-wrap: nowrap !important;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  white-space: nowrap;
overflow: visible;
  padding: 8px 4px 12px 4px; 
  margin: 0 -4px; 
  -webkit-overflow-scrolling: touch; 
  scrollbar-width: thin; 
  scrollbar-color: #c1c1c1 transparent;
  }
  .entity-test-plans .section-title {
  flex: 1 1;
  min-width: 200px;
  }
  .entity-test-plans > div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;
}
@media (max-width: 1200px) {
  .entity-test-plans > div:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .test-plans-actions-container {
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
  }
}

  .test-plans-actions-container::-webkit-scrollbar {
  height: 6px;
}
.test-plans-actions-container .navbar-button {
  flex: 0 0 auto; 
  min-width: max-content; 
  white-space: nowrap;
  padding: 8px 12px;
}

.test-plans-actions-container::-webkit-scrollbar-thumb {
  background: transparent;
  background: #c1c1c1;
  border-radius: 3px;
}
.test-plans-actions-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
  
  .navbar-button span {
    display: none;
  }
  
  .navbar-button {
    padding: 10px;
  }
  
  .entity-tabs {
    flex-wrap: wrap;
  }
  
  .tab-btn {
    flex: 1 1;
    min-width: 100px;
    text-align: center;
    padding: 10px;
  }
  
  .entity-grid {
    grid-template-columns: 1fr;
  }
  
  .test-plans-table {
    font-size: 14px;
  }
  
  .test-plans-table th,
  .test-plans-table td {
    padding: 8px 12px;
  }
  .test-plans-table td {
  vertical-align: middle;
    white-space: nowrap;
}
  .action-buttons {
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .action-btn {
    width: 28px;
    height: 28px;
  }
  
  .modal {
    max-width: 95%;
    margin: 10px;
  }
}

@media (max-width: 576px) {
  .test-plans-title {
    font-size: 24px;
  }
  
  .test-plans-subtitle {
    font-size: 14px;
  }
  
  .project-dropdown {
    max-width: 100%;
  }
  
  .section-title {
    font-size: 18px;
  }
  
  .test-plan-header {
    flex-direction: column;
    gap: 4px;
   align-items: center;
  justify-content: space-between;
  width: 100%;
  }
  
  .test-plan-header input[type="checkbox"] {
    align-self: flex-start;
  }
  
  .expand-row-btn {
    align-self: flex-end;
  }
  
  .modal-header {
    padding: 15px;
  }
  
  .modal-body {
    padding: 15px;
  }
  
  .modal-footer {
    padding: 15px;
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .test-plans-actions-container {
    justify-content: center;
  }
  
  .entity-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .add-sprint-btn {
    align-self: flex-end;
  }
  
  .entity-header {
    flex-direction: column;
    gap: 8px;
  }

  .entity-header-right {
    align-self: flex-end;
  }
  
  .action-feedback {
    left: 20px;
    right: 20px;
    top: 10px;
  }
}

/* High Zoom Level Fixes */
@media (min-resolution: 120dpi) {
  .test-plans-container {
    zoom: 0.9;
  }
}

@media (min-resolution: 144dpi) {
  .test-plans-container {
    zoom: 0.8;
  }
}


@media print {
  .test-plans-actions,
  .action-buttons,
  .add-sprint-btn,
  .entity-actions,
  .expand-row-btn,
  .modal-close,
  .btn {
    display: none !important;
  }
  
  .test-plans-container {
    padding: 0;
  }
  
  .entity-item {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  
  .test-plans-table {
    min-width: auto;
  }
}
/* Modal Header Styling */
.modal-header {
  background: var(--modal-background, var(--surface, #fff));
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--text-muted, #64748b);
  transition: all 0.2s ease;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  background-color: var(--surface-hover, #f8fafc);
  color: var(--text-primary, #0f172a);
}

/* Modal Content Styling */
.modal-content {
  /* padding: 20px;
  max-height: 60vh; */
  overflow-y: auto;
}

.confirmation-warning {
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  margin-bottom: 20px;
}

.warning-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.warning-content h4 {
  margin: 0 0 6px 0;
  color: #856404;
  font-size: 16px;
  font-weight: 600;
}

.warning-content p {
  margin: 0;
  color: #856404;
  font-size: 14px;
  line-height: 1.4;
}

/* Form Elements Styling */
.selection-count {
  font-size: 14px;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.btn.primary {
  background-color: #4361ee;
  border: 1px solid #4361ee;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}
.btn.primary:hover:not(:disabled) {
  background-color: #3a56d4;
  border-color: #3a56d4;
}
.btn.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Unlink Button Styling */
.btn.danger {
  background-color: var(--danger);
  border: 1px solid #dc3545;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn.danger:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #bd2130;
}

.btn.danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Secondary Button Styling */
.btn.secondary {
  background-color: var(--bg-primary);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn.secondary:hover:not(:disabled) {
  background-color: var(--bg-tertiary);
  border-color: #adb5bd;
}

.btn.secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn.primary,
.btn.secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn .loading-spinner.small {
  margin-bottom: 0;
  flex-shrink: 0;
}
/* Case Item Selection Indicator */
.case-selection-indicator {
  width: 18px;
  height: 18px;
  border: 2px solid #dee2e6;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.case-item.selected .case-selection-indicator {
  background-color: #4361ee;
  border-color: #4361ee;
}

.case-item.selected .case-selection-indicator svg {
  color: white;
  display: block;
}

.case-selection-indicator svg {
  display: none;
  width: 12px;
  height: 12px;
}
.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-secondary);
}

.select-all-container {
  margin-bottom: 12px;
}

.select-all-btn {
  padding: 6px 12px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border);
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-secondary);
  transition: all 0.2s ease;
}

.select-all-btn:hover {
  background-color: var(--bg-tertiary);
}

.select-all-btn.selected {
  background-color: #4361ee;
  color: white;
  border-color: #4361ee;
}

/* Test Cases List Styling */
.test-cases-vertical-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 8px;
}

.case-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.case-item:hover {
  background-color: var(--bg-primary);
}

.case-item.selected {
  background-color: var(--bg-tertiary);
  border-color: #4361ee;
}

.case-name {
  font-size: 14px;
  color: var(--text-primary);
}

.case-selection-indicator {
  color: #4361ee;
  display: flex;
  align-items: center;
}

/* Additional Warning Styling */
.additional-warning {
  padding: 12px;
  background-color: var(--bg-primary);
  border-radius: 4px;
  margin-top: 16px;
  border-left: 4px solid #4361ee;
}

.additional-warning p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

/* Modal Footer Styling */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  background-color: var(--bg-primary);
}

/* Loading and Empty States */
.loading-state, .empty-state {
  padding: 20px;
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
}

/* Error Message Styling */
.error-message {
  color: var(--danger);
  font-size: 14px;
  margin-top: 8px;
}

/* Responsive Adjustments */
@media (max-width: 576px) {
  .modal {
    max-width: 95%;
  }
  
  .modal-content {
    padding: 15px;
  }
  
  .confirmation-warning {
    flex-direction: column;
    gap: 8px;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .btn{
    background-color: var(--info);
    width: 100%;
  }
}

/* Sprint/release/epic editor modal: keep chrome fixed and scroll only form content. */
.modal-overlay.sprint-modal-overlay {
  position: fixed;
  inset: 0;
  top: 0;
  width: auto;
  height: auto;
  padding: 20px;
  overflow: hidden;
  animation: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.modal.sprint-modal {
  width: min(92vw, 560px);
  max-width: 560px;
  max-height: min(90dvh, 760px);
  max-height: min(90vh, 760px);
  display: flex;
  flex-direction: column;
  position: relative;
  top: auto;
  left: auto;
  border-radius: 12px;
  border: 1px solid var(--rt-border, var(--border, #e2e8f0));
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.22);
  background: var(--rt-surface, var(--surface, #fff));

  right: auto;
  bottom: auto;
  margin: 0;
  overflow: hidden;
  transform: none;
  animation: none;
  box-sizing: border-box;
}

.sprint-modal .modal-header,
.sprint-modal__header {
  flex: 0 0 auto;
  border-radius: 12px 12px 0 0;
  padding: 16px 18px;
  background: var(--rt-surface, var(--surface, #fff));
  color: var(--rt-text, var(--text-primary, #0f172a));
  border-bottom: 1px solid var(--rt-border, var(--border, #e2e8f0));
}

.sprint-modal__header h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: inherit;
}

.sprint-modal__subtitle {
  margin: 4px 0 0;
  font-size: 0.8125rem;
  color: var(--rt-text-secondary, var(--text-secondary, #64748b));
  font-weight: 400;
}

.sprint-modal__req {
  color: var(--danger, #ef4444);
}

.sprint-modal-form {
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.sprint-modal .modal-content,
.sprint-modal__body {
  min-height: 0;
  padding: 16px 18px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.sprint-modal .modal-footer,
.sprint-modal__footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  background-color: var(--rt-surface, var(--surface, #fff));
  border-top: 1px solid var(--rt-border, var(--border, #e2e8f0));
  border-radius: 0 0 12px 12px;
}

@media (max-width: 640px) {
  .modal-overlay.sprint-modal-overlay {
    padding: 12px;
  }

  .modal.sprint-modal {
    width: 100%;
    max-width: 100%;
    max-height: calc(100vh - 24px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/test-plans.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;GACG,aAAa;EACd,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EAGtB,YAAY;EACZ,cAAc;AAHhB;;AAMA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,2EAA2E;EAC3E,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;;AAEd;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;;EAEE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,0FAA0F;AAC1F;EACE,eAAe;EACf,QAAQ;EACR,yDAAyD;EACzD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yDAAyD;EACzD,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,QAAQ;EACR,2DAA2D;EAC3D,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,WAAW;EACb;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;EAGA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;KACG,aAAa;EAChB,4BAA4B;EAC5B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB,iBAAiB;EACf,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,qBAAqB;EACrB,oCAAoC;EACpC;EACA;EACA,SAAO;EACP,gBAAgB;EAChB;EACA;EACA,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,eAAe;EACjB;AACF;;EAEE;EACA,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EAIvB,mBAAmB;EACnB,kBAAkB;AAHpB;AAKA;EACE,mBAAmB;AACrB;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;EACA;EACA,sBAAsB;IACpB,mBAAmB;AACvB;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;EACd;AAzHF;;AA4HA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;GACT,mBAAmB;EACpB,8BAA8B;EAC9B,WAAW;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;;AAGA;EACE;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,yBAAyB;AACzB;EACE,yDAAyD;EACzD,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE;qBACmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,WAAW;EACb;AACF;;AAEA,sFAAsF;AACtF;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EAGV,mBAAmB;EACnB,0DAA0D;EAC1D,8CAA8C;EAC9C,mDAAmD;;EAEnD,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,mDAAmD;EACnD,mDAAmD;EACnD,iEAAiE;AACnE;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,yDAAyD;EACzD,8DAA8D;EAC9D,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,8BAA8B;EAChC;AACF","sourcesContent":["/* Test Plans Responsive Styles */\n.test-plans-container {\n  width: 100%;\n  max-width: 100%;\n  overflow: visible;\n  padding: 0;\n  box-sizing: border-box;\n  background: transparent;\n  color: var(--text-primary);\n}\n\n/* Header Styles */\n.test-plans-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n  padding: 15px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.header-with-back {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  background-color: var(--bg-tertiary);\n}\n\n.test-plans-title {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.test-plans-subtitle {\n  margin: 5px 0 0;\n  color: var(--text-muted);\n  font-size: 16px;\n}\n\n.test-plans-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.test-plans-header--embedded {\n  justify-content: flex-end;\n  padding-top: 0;\n  margin-bottom: 12px;\n}\n\n.rt-plans-entity-embed .entity-layout {\n  min-height: 480px;\n}\n\n/* Project Selection */\n.project-selection {\n  margin-bottom: 20px;\n}\n\n.project-selection label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.project-dropdown {\n  width: 100%;\n  max-width: 350px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 16px;\n  background-color: var(--surface);\n}\n\n/* Entity Layout */\n.entity-layout {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  width: 100%;\n}\n\n.entity-left-panel {\n  flex: 0 0 320px;\n  min-width: 0;\n}\n\n.entity-right-panel {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Entity Tabs */\n.entity-tabs {\n  display: flex;\n  border-bottom: 1px solid #dee2e6;\n  margin-bottom: 15px;\n}\n\n.tab-btn {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  font-weight: 500;\n  color: var(--text-muted);\n  transition: all 0.2s ease;\n}\n\n.tab-btn.active {\n  color: #4361ee;\n  border-bottom-color: #4361ee;\n}\n\n.tab-btn:hover:not(.active) {\n  color: var(--text-secondary);\n}\n\n/* Entity List */\n.entity-list-container {\n  background: var(--surface);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  margin-bottom: 20px;\n}\n\n.entity-list-container .pagination {\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin: 1rem 0 0;\n}\n\n.entity-list-container .pageItem {\n  padding: 0.4rem 0.5rem;\n  min-width: 32px;\n  font-size: 0.85rem;\n}\n\n.entity-list-container .navButton {\n  padding: 0.4rem 0.6rem;\n}\n\n.entity-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.sidebar-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.add-sprint-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #4361ee;\n  background-color: #4361ee;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-sprint-btn:hover {\n  background-color: #3a56d4;\n}\n\n/* Entity Grid */\n.entity-grid {\n   display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.entity-item {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n.entity-item {\n  min-width: 0; \n  flex-shrink: 0;\n}\n\n.entity-item:hover {\n  border-color: #4361ee;\n  box-shadow: 0 4px 12px rgba(67, 97, 238, 0.15);\n}\n\n.entity-item.active {\n  border-color: #4361ee;\n  background-color: #f8f9ff;\n}\n\n.entity-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.entity-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.entity-name {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.3;\n}\n\n.entity-name-compact {\n  flex: 0 1 auto;\n  display: block;\n  -webkit-line-clamp: unset;\n  overflow: visible;\n}\n\n.entity-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-btn:hover {\n  background-color: var(--bg-primary);\n}\n\n.action-btn.edit:hover {\n  border-color: var(--warning);\n  color: var(--warning);\n}\n\n.action-btn.delete:hover {\n  border-color: var(--danger);\n  color: var(--danger);\n}\n\n.entity-description {\n  color: var(--text-muted);\n  font-size: 14px;\n  margin-bottom: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.4;\n}\n\n.entity-dates {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n.entity-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  min-width: 0;\n}\n\n.entity-meta .assignee {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n/* Status Badges */\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-active {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-completed {\n  background-color: #d1ecf1;\n  color: #0c5460;\n}\n\n.status-planned {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-default {\n  background-color: var(--bg-primary);\n  color: var(--text-secondary);\n}\n\n.priority-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.priority-high {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.priority-medium {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.priority-low {\n  background-color: #d1ecf1;\n  color: #0c5460;\n}\n\n.priority-default {\n  background-color: var(--bg-primary);\n  color: var(--text-secondary);\n}\n\n/* Test Plans Table */\n.entity-test-plans {\n  background: var(--surface);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  overflow: visible;\n  max-width: 100%;\n}\n\n.test-plans-table-container {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.section-title {\n  margin: 0 0 20px;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.test-plans-actions-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.navbar-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.navbar-button.primary {\n  background-color: #4361ee;\n  border: 1px solid #4361ee;\n  color: white;\n}\n\n.navbar-button.primary:hover {\n  background-color: #3a56d4;\n  border-color: #3a56d4;\n}\n\n.navbar-button.secondary {\n  background-color: #f5f5f5;\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n}\n\n.navbar-button.secondary:hover {\n  background-color: var(--bg-tertiary);\n  border-color: #adb5bd;\n}\n\n/* Table Container — page scrolls vertically; table scrolls horizontally */\n.table-responsive-wrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: none;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  /* Keep sticky thead z-index local so it cannot paint above GlobalLoader. */\n  isolation: isolate;\n  position: relative;\n  z-index: 0;\n}\n\n.test-plans-table {\n  width: 100%;\n  min-width: 1200px;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.test-plans-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n\n}\n\n.test-plans-table th {\n  background-color: var(--bg-primary);\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.test-plans-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  vertical-align: top;\n}\n\n.test-plans-table th.column-name,\n.test-plans-table td.column-name {\n  width: 28%;\n  min-width: 180px;\n  max-width: 320px;\n  overflow: hidden;\n}\n\n/* Override global .column-actions max-width (projects.css) so all icons fit */\n.test-plans-table th.column-actions,\n.test-plans-table td.column-actions {\n  width: 1%;\n  min-width: 300px;\n  max-width: none;\n  white-space: nowrap;\n  overflow: visible;\n  vertical-align: middle;\n}\n\n.test-plans-table th.column-actions {\n  padding-left: 72px;\n  text-align: left;\n}\n\n.test-plans-table th.column-execution-history,\n.test-plans-table td.column-execution-history {\n  width: 12%;\n  min-width: 120px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.test-plans-table .column-execution-history .action-btn.execution-history {\n  background: none;\n  border: 1px solid transparent;\n  padding: 0;\n  margin: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  line-height: 0;\n}\n\n.test-plans-table .column-execution-history .action-btn.execution-history:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  border-color: rgba(0, 0, 0, 0.08);\n  color: #007bff;\n}\n\n.test-plans-table .column-execution-history .action-btn.execution-history svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n  pointer-events: none;\n}\n\n/* Test Plan Header */\n.test-plan-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n}\n\n.test-plan-header input[type=\"checkbox\"] {\n  margin-top: 3px;\n  flex-shrink: 0;\n}\n\n.test-plan-name-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.test-plan-name-content {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.test-plan-name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 100%;\n  font-weight: 500;\n}\n\n.test-plan-description {\n  color: var(--text-muted);\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.expand-row-btn {\n  flex-shrink: 0;\n  margin-left: 8px;\n  font-weight: bold;\n}\n\n.expand-row-btn:hover {\n  color: #4361ee;\n}\n\n.expand-row-btn.expanded {\n  transform: rotate(180deg);\n}\n\n/* Progress Bar */\n.progress-bar-container {\n  width: 100%;\n  height: 24px;\n  background-color: var(--bg-tertiary);\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-bar {\n  height: 100%;\n  background-color: #4361ee;\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n}\n\n/* Test Suites */\n.test-suites-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.test-suite-badge {\n  padding: 4px 8px;\n  background-color: var(--bg-tertiary);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.test-suite-badge:hover {\n  background-color: #dee2e6;\n}\n\n.test-suite-badge.clickable:hover {\n  background-color: #4361ee;\n  color: white;\n}\n\n.no-suites {\n  color: var(--text-muted);\n  font-style: italic;\n  font-size: 14px;\n}\n\n/* Pass Rate */\n.pass-rate-low {\n  color: var(--danger);\n  font-weight: 600;\n}\n\n.pass-rate-medium {\n  color: var(--warning);\n  font-weight: 600;\n}\n\n.pass-rate-high {\n  color: var(--success);\n  font-weight: 600;\n}\n\n/* Action Buttons */\n.test-plans-table .action-buttons {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  gap: 6px;\n  justify-content: flex-start;\n  align-items: center;\n  width: max-content;\n  min-width: max-content;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.test-plans-table .action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.action-btn:hover {\n  background-color: var(--bg-primary);\n}\n\n.action-btn.view:hover {\n  border-color: #4361ee;\n  color: #4361ee;\n}\n\n.action-btn.schedule:hover {\n  border-color: #6f42c1;\n  color: #6f42c1;\n}\n\n.action-btn.play:hover {\n  border-color: var(--success);\n  color: var(--success);\n}\n\n.action-btn.edit:hover {\n  border-color: var(--warning);\n  color: var(--warning);\n}\n\n.action-btn.delete:hover {\n  border-color: var(--danger);\n  color: var(--danger);\n}\n\n.action-btn.link:hover {\n  border-color: var(--info);\n  color: var(--info);\n}\n\n.action-btn.unlink:hover {\n  border-color: #fd7e14;\n  color: #fd7e14;\n}\n\n.action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.action-btn:disabled:hover {\n  background-color: var(--surface);\n  border-color: #dee2e6;\n  color: var(--text-muted);\n}\n\n/* Expanded Row */\n.expanded-row td {\n  background-color: var(--bg-primary);\n  padding: 0;\n}\n\n.expanded-content {\n  padding: 20px;\n}\n\n.expanded-section h4 {\n  margin: 0 0 15px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.suites-table-container {\n  overflow-x: auto;\n}\n\n.suites-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.suites-table th {\n  background-color: var(--bg-tertiary);\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-secondary);\n  border-bottom: 1px solid #dee2e6;\n}\n\n.suites-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n.badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badge-success {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.badge-disabled {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.no-suites-message {\n  text-align: center;\n  padding: 20px;\n  color: var(--text-muted);\n}\n\n.btn-link-suites {\n  padding: 8px 16px;\n  background-color: #4361ee;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n  transition: all 0.2s ease;\n}\n\n.btn-link-suites:hover {\n  background-color: #3a56d4;\n}\n\n/* Pagination */\n.pagination-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  padding: 10px 0;\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--text-muted);\n}\n\n.empty-state p {\n  margin: 0 0 15px;\n  font-size: 16px;\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4361ee;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 15px;\n}\n\n.loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 20px;\n}\n\n.loading-spinner.small {\n  width: 24px;\n  height: 24px;\n  border-width: 2px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error States */\n.error-container {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 15px;\n}\n\n.error-state {\n  text-align: center;\n  padding: 30px 20px;\n  color: var(--danger);\n}\n\n/* Action Feedback — above schedule/create modals (z-index 11000) */\n.action-feedback {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 20px;\n  border-radius: 4px;\n  color: white;\n  font-weight: 500;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: slideIn 0.3s ease;\n}\n\n.action-feedback.success {\n  background-color: var(--success);\n}\n\n.action-feedback.error {\n  background-color: var(--danger);\n}\n\n.action-feedback.warning {\n  background-color: var(--warning);\n  color: var(--text-primary);\n}\n\n.action-feedback.info {\n  background-color: var(--info);\n}\n\n.action-feedback button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Create Test Execution modal — scoped to avoid global .modal slide/transform conflicts */\n.test-execution-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 12000;\n  animation: testExecutionOverlayFadeIn 0.12s ease-out;\n}\n\n.test-execution-modal {\n  background: var(--modal-background, var(--surface));\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: var(--modal-shadow, 0 10px 30px rgba(0, 0, 0, 0.2));\n  position: relative;\n  transform: none;\n  box-sizing: border-box;\n}\n\n.test-execution-modal .modal-header {\n  flex: 0 0 auto;\n  background: var(--modal-background, var(--surface, #fff));\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 12px 12px 0 0;\n}\n\n.test-execution-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary, #0f172a);\n}\n\n.test-execution-modal-form {\n  min-height: 0;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n}\n\n.test-execution-modal .modal-content {\n  min-height: 0;\n  padding: 20px;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.test-execution-modal .modal-footer {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  background-color: var(--bg-primary);\n  border-radius: 0 0 8px 8px;\n}\n\n.test-execution-modal .form-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin: 0;\n}\n\n.test-execution-modal .form-group {\n  margin-bottom: 0;\n}\n\n.test-execution-modal .form-group > label {\n  display: block;\n  margin: 0 0 6px;\n  min-height: 0;\n  line-height: 1.25;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.test-execution-modal .form-row > .form-group {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.test-execution-modal .form-row > .form-group > input,\n.test-execution-modal .form-row > .form-group > select,\n.test-execution-modal .form-row > .form-group > .relative {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.test-execution-modal .test-execution-field-error {\n  margin: 4px 0 0;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--danger);\n  font-size: 12px;\n  line-height: 1.3;\n  font-weight: 500;\n}\n\n.test-execution-modal .test-execution-field-hint {\n  margin: 4px 0 0;\n  padding: 0;\n  font-size: 0.85rem;\n  line-height: 1.3;\n  color: var(--text-muted);\n}\n\n.test-execution-modal .test-execution-field-hint--success {\n  color: var(--success);\n}\n\n.test-execution-modal .form-info {\n  margin: 0;\n}\n\n.test-execution-modal .form-info p {\n  margin: 0 0 4px;\n}\n\n.test-execution-modal .form-info p:last-child {\n  margin-bottom: 0;\n}\n\n@keyframes testExecutionOverlayFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  /* padding: 20px; */\n}\n\n.modal {\n  background: var(--surface);\n  border-radius: 8px;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  width: 100%;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--text-primary, #0f172a);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  color: var(--text-primary);\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.btn {\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background-color: #4361ee;\n  border: 1px solid #4361ee;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #3a56d4;\n  border-color: #3a56d4;\n}\n\n.btn-outline {\n  background-color: var(--surface);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n}\n\n.btn-outline:hover {\n  background-color: var(--bg-primary);\n}\n\n/* Schedule Modal — scoped to avoid global .modal slide/transform conflicts */\n.schedule-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: var(--modal-backdrop, rgba(0, 0, 0, 0.5));\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 11000;\n  animation: scheduleModalOverlayFadeIn 0.12s ease-out;\n}\n\n.schedule-modal {\n  background: var(--surface);\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  position: relative;\n  top: auto;\n  left: auto;\n  transform: none;\n  animation: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.schedule-modal .modal-header {\n  background: var(--modal-background, var(--surface, #fff));\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 12px 12px 0 0;\n  flex: 0 0 auto;\n}\n\n.schedule-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--text-primary, #0f172a);\n}\n\n.schedule-modal .modal-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n}\n\n.schedule-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  background-color: var(--bg-primary);\n  border-radius: 0 0 8px 8px;\n  flex: 0 0 auto;\n}\n\n@keyframes scheduleModalOverlayFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.schedule-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: flex;\n  gap: 20px;\n}\n\n.form-column {\n  flex: 1;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #4361ee;\n  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.2);\n}\n\n.comment-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.full-width {\n  width: 100%;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .entity-layout {\n    flex-direction: column;\n  }\n  \n  .entity-left-panel {\n    flex: 1;\n    width: 100%;\n  }\n  \n  .entity-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n  \n  .test-plans-table {\n    min-width: 1100px;\n  }\n}\n\n@media (max-width: 992px) {\n  .test-plans-table {\n    min-width: 1000px;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n@media (max-width: 768px) {\n  .test-plans-actions-container {\n    justify-content: flex-start;\n    gap: 8px;\n  }\n  \n  .test-plans-actions-container .navbar-button {\n    padding: 6px 10px;\n    font-size: 14px;\n  }\n  \n\n  .test-plans-actions-container .navbar-button.responsive-btn span {\n    display: none;\n  }\n  \n  .test-plans-actions-container .navbar-button.responsive-btn {\n    padding: 8px;\n    width: 40px;\n    justify-content: center;\n  }\n}\n\n/* High zoom level specific styles */\n@media (min-resolution: 150dpi) {\n  .test-plans-actions-container {\n    gap: 6px;\n  }\n  \n  .test-plans-actions-container .navbar-button {\n    padding: 6px 10px;\n    font-size: 14px;\n  }\n}\n@media (max-width: 768px) {\n  .action-buttons {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .test-plans-table .action-buttons {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  \n  .test-plans-table td {\n    white-space: normal;\n  }\n}\n@media (max-width: 768px) {\n  .test-plans-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .test-plans-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .test-plans-actions-container {\n     display: flex;\n  flex-wrap: nowrap !important;\n  gap: 10px;\n  justify-content: flex-end;\n  align-items: center;\n  white-space: nowrap;\noverflow: visible;\n  padding: 8px 4px 12px 4px; \n  margin: 0 -4px; \n  -webkit-overflow-scrolling: touch; \n  scrollbar-width: thin; \n  scrollbar-color: #c1c1c1 transparent;\n  }\n  .entity-test-plans .section-title {\n  flex: 1;\n  min-width: 200px;\n  }\n  .entity-test-plans > div:first-child {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  width: 100%;\n}\n@media (max-width: 1200px) {\n  .entity-test-plans > div:first-child {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .test-plans-actions-container {\n    justify-content: flex-start;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}\n\n  .test-plans-actions-container::-webkit-scrollbar {\n  height: 6px;\n}\n.test-plans-actions-container .navbar-button {\n  flex: 0 0 auto; \n  min-width: max-content; \n  white-space: nowrap;\n  padding: 8px 12px;\n}\n\n.test-plans-actions-container::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 3px;\n}\n.test-plans-actions-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n.test-plans-actions-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n  \n  .navbar-button span {\n    display: none;\n  }\n  \n  .navbar-button {\n    padding: 10px;\n  }\n  \n  .entity-tabs {\n    flex-wrap: wrap;\n  }\n  \n  .tab-btn {\n    flex: 1;\n    min-width: 100px;\n    text-align: center;\n    padding: 10px;\n  }\n  \n  .entity-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .test-plans-table {\n    font-size: 14px;\n  }\n  \n  .test-plans-table th,\n  .test-plans-table td {\n    padding: 8px 12px;\n  }\n  .test-plans-table td {\n  vertical-align: middle;\n    white-space: nowrap;\n}\n  .action-buttons {\n    flex-wrap: wrap;\n    gap: 5px;\n  }\n  \n  .action-btn {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .modal {\n    max-width: 95%;\n    margin: 10px;\n  }\n}\n\n@media (max-width: 576px) {\n  .test-plans-title {\n    font-size: 24px;\n  }\n  \n  .test-plans-subtitle {\n    font-size: 14px;\n  }\n  \n  .project-dropdown {\n    max-width: 100%;\n  }\n  \n  .section-title {\n    font-size: 18px;\n  }\n  \n  .test-plan-header {\n    flex-direction: column;\n    gap: 4px;\n   align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  }\n  \n  .test-plan-header input[type=\"checkbox\"] {\n    align-self: flex-start;\n  }\n  \n  .expand-row-btn {\n    align-self: flex-end;\n  }\n  \n  .modal-header {\n    padding: 15px;\n  }\n  \n  .modal-body {\n    padding: 15px;\n  }\n  \n  .modal-footer {\n    padding: 15px;\n    flex-direction: column;\n  }\n  \n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .test-plans-actions-container {\n    justify-content: center;\n  }\n  \n  .entity-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .add-sprint-btn {\n    align-self: flex-end;\n  }\n  \n  .entity-header {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .entity-header-right {\n    align-self: flex-end;\n  }\n  \n  .action-feedback {\n    left: 20px;\n    right: 20px;\n    top: 10px;\n  }\n}\n\n/* High Zoom Level Fixes */\n@media (min-resolution: 120dpi) {\n  .test-plans-container {\n    zoom: 0.9;\n  }\n}\n\n@media (min-resolution: 144dpi) {\n  .test-plans-container {\n    zoom: 0.8;\n  }\n}\n\n\n@media print {\n  .test-plans-actions,\n  .action-buttons,\n  .add-sprint-btn,\n  .entity-actions,\n  .expand-row-btn,\n  .modal-close,\n  .btn {\n    display: none !important;\n  }\n  \n  .test-plans-container {\n    padding: 0;\n  }\n  \n  .entity-item {\n    break-inside: avoid;\n  }\n  \n  .test-plans-table {\n    min-width: auto;\n  }\n}\n/* Modal Header Styling */\n.modal-header {\n  background: var(--modal-background, var(--surface, #fff));\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: var(--text-primary, #0f172a);\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: var(--text-muted, #64748b);\n  transition: all 0.2s ease;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.close-btn:hover {\n  background-color: var(--surface-hover, #f8fafc);\n  color: var(--text-primary, #0f172a);\n}\n\n/* Modal Content Styling */\n.modal-content {\n  /* padding: 20px;\n  max-height: 60vh; */\n  overflow-y: auto;\n}\n\n.confirmation-warning {\n  display: flex;\n  gap: 12px;\n  padding: 12px 16px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 6px;\n  margin-bottom: 20px;\n}\n\n.warning-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.warning-content h4 {\n  margin: 0 0 6px 0;\n  color: #856404;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.warning-content p {\n  margin: 0;\n  color: #856404;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Form Elements Styling */\n.selection-count {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n.btn.primary {\n  background-color: #4361ee;\n  border: 1px solid #4361ee;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n.btn.primary:hover:not(:disabled) {\n  background-color: #3a56d4;\n  border-color: #3a56d4;\n}\n.btn.primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Unlink Button Styling */\n.btn.danger {\n  background-color: var(--danger);\n  border: 1px solid #dc3545;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.btn.danger:hover:not(:disabled) {\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n\n.btn.danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Secondary Button Styling */\n.btn.secondary {\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.btn.secondary:hover:not(:disabled) {\n  background-color: var(--bg-tertiary);\n  border-color: #adb5bd;\n}\n\n.btn.secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn.primary,\n.btn.secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn .loading-spinner.small {\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n/* Case Item Selection Indicator */\n.case-selection-indicator {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #dee2e6;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.case-item.selected .case-selection-indicator {\n  background-color: #4361ee;\n  border-color: #4361ee;\n}\n\n.case-item.selected .case-selection-indicator svg {\n  color: white;\n  display: block;\n}\n\n.case-selection-indicator svg {\n  display: none;\n  width: 12px;\n  height: 12px;\n}\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.select-all-container {\n  margin-bottom: 12px;\n}\n\n.select-all-btn {\n  padding: 6px 12px;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--text-secondary);\n  transition: all 0.2s ease;\n}\n\n.select-all-btn:hover {\n  background-color: var(--bg-tertiary);\n}\n\n.select-all-btn.selected {\n  background-color: #4361ee;\n  color: white;\n  border-color: #4361ee;\n}\n\n/* Test Cases List Styling */\n.test-cases-vertical-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.case-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.case-item:hover {\n  background-color: var(--bg-primary);\n}\n\n.case-item.selected {\n  background-color: var(--bg-tertiary);\n  border-color: #4361ee;\n}\n\n.case-name {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.case-selection-indicator {\n  color: #4361ee;\n  display: flex;\n  align-items: center;\n}\n\n/* Additional Warning Styling */\n.additional-warning {\n  padding: 12px;\n  background-color: var(--bg-primary);\n  border-radius: 4px;\n  margin-top: 16px;\n  border-left: 4px solid #4361ee;\n}\n\n.additional-warning p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n/* Modal Footer Styling */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  background-color: var(--bg-primary);\n}\n\n/* Loading and Empty States */\n.loading-state, .empty-state {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n/* Error Message Styling */\n.error-message {\n  color: var(--danger);\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 576px) {\n  .modal {\n    max-width: 95%;\n  }\n  \n  .modal-content {\n    padding: 15px;\n  }\n  \n  .confirmation-warning {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .modal-footer {\n    flex-direction: column;\n  }\n  \n  .btn{\n    background-color: var(--info);\n    width: 100%;\n  }\n}\n\n/* Sprint/release/epic editor modal: keep chrome fixed and scroll only form content. */\n.modal-overlay.sprint-modal-overlay {\n  position: fixed;\n  inset: 0;\n  top: 0;\n  width: auto;\n  height: auto;\n  padding: 20px;\n  overflow: hidden;\n  animation: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 12000;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n.modal.sprint-modal {\n  width: min(92vw, 560px);\n  max-width: 560px;\n  max-height: min(90dvh, 760px);\n  max-height: min(90vh, 760px);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  top: auto;\n  left: auto;\n  margin: 0;\n  overflow: hidden;\n  border-radius: 12px;\n  border: 1px solid var(--rt-border, var(--border, #e2e8f0));\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.22);\n  background: var(--rt-surface, var(--surface, #fff));\n\n  right: auto;\n  bottom: auto;\n  margin: 0;\n  overflow: hidden;\n  transform: none;\n  animation: none;\n  box-sizing: border-box;\n}\n\n.sprint-modal .modal-header,\n.sprint-modal__header {\n  flex: 0 0 auto;\n  border-radius: 12px 12px 0 0;\n  padding: 16px 18px;\n  background: var(--rt-surface, var(--surface, #fff));\n  color: var(--rt-text, var(--text-primary, #0f172a));\n  border-bottom: 1px solid var(--rt-border, var(--border, #e2e8f0));\n}\n\n.sprint-modal__header h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: inherit;\n}\n\n.sprint-modal__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.8125rem;\n  color: var(--rt-text-secondary, var(--text-secondary, #64748b));\n  font-weight: 400;\n}\n\n.sprint-modal__req {\n  color: var(--danger, #ef4444);\n}\n\n.sprint-modal-form {\n  min-height: 0;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sprint-modal .modal-content,\n.sprint-modal__body {\n  min-height: 0;\n  padding: 16px 18px;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.sprint-modal .modal-footer,\n.sprint-modal__footer {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 18px;\n  background-color: var(--rt-surface, var(--surface, #fff));\n  border-top: 1px solid var(--rt-border, var(--border, #e2e8f0));\n  border-radius: 0 0 12px 12px;\n}\n\n@media (max-width: 640px) {\n  .modal-overlay.sprint-modal-overlay {\n    padding: 12px;\n  }\n\n  .modal.sprint-modal {\n    width: 100%;\n    max-width: 100%;\n    max-height: calc(100vh - 24px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
